<template>
    <div>
        <div v-if="isLoading" class="text-center">
            <i class="i-ph-spinner animate-spin text-3xl inline-block"/>
        </div>
        <div v-if="patronOverview">
            <div class="setting-header mt-2">E-postadresse for innkommende bilag</div>
            <div class="setting-group setting">
                <div class="flex items-center gap-4">
                    <span>{{ tenantEmailAddress }}</span>
                    <a :href="'mailto:'+tenantEmailAddress" class="flex items-center text-xs">
                        <UButton
                            variant="outline"
                            color="neutral"
                            size="sm"
                            label="Send e-post"
                            icon="i-ph-envelope"
                        />
                    </a>
                </div>
            </div>
        </div>
        <template v-if="ShowPatronDebugInfo.isEnabled()">
            <div v-if="patronOverview" class="py-2">
                <span class="setting-header">Patron data</span>
                <pre class="text-sm setting-group py-2"><code lang="JSON">{{ JSON.stringify(patronOverview, null, 2) }}</code></pre>
            </div>
            <div v-else class="setting-group setting">Ingen data i Patron funnet</div>
        </template>
    </div>
</template>

<script setup lang="ts">

import {computed, onMounted, onUnmounted, ref} from 'vue'
import {selectedOrg} from '@/tenants/org.service'
import {fetchPatronOverview} from '@/services/infrastructure/patron.service'
import {useEmitter} from '@/services/infrastructure/emitter'
import {ORG_SWITCHED} from '@/types/events'
import {getEnvironment} from '@/services/infrastructure/envhelper.service'
import {PatronOverview} from '@tritt/patron-client-ts'
import {ShowPatronDebugInfo} from '@/org-settings/settings.features'

const {onEvent, cleanUp} = useEmitter()
const isLoading = ref(false)

const patronOverview = ref<PatronOverview>()

const tenantEmailAddress = computed(() => {
    if (!patronOverview.value) {
        return ''
    }
    const hri = patronOverview.value.generatedHri
    const environment = getEnvironment()
    if (environment === 'staging') {
        return hri + '@staging.contabilag.no'
    }
    if (environment === 'preproduction') {
        return hri + '@preprod.contabilag.no'
    }
    if (environment === 'production') {
        return hri + '@pro.contabilag.no'
    }
    return hri + '@test.no'
})

const refreshPatron = async () => {
    if (selectedOrg.value) {
        patronOverview.value = await fetchPatronOverview(selectedOrg.value.organizationId)
    }
}

onMounted(async () => {
    await refreshPatron()
    onEvent(ORG_SWITCHED, refreshPatron)
})

onUnmounted(cleanUp)

</script>


<style scoped>

</style>